declare global {
    interface Window {
        dataLayer?: any;
    }
}

export default defineNuxtPlugin({
    parallel: true,
    async setup() {
        function gtag(a: string, b: string, c: Record<string, string | number>) {
            window.dataLayer.push(arguments);
        }

        function setDefaultGa4Consent() {
            const consentGranted = !localStorage.getItem("consentGranted")
                ? "granted"
                : localStorage.getItem("consentGranted") === "true"
                ? "granted"
                : "denied";

            gtag("consent", "default", {
                ad_user_data: consentGranted,
                ad_personalization: consentGranted,
                ad_storage: consentGranted,
                analytics_storage: consentGranted,
                wait_for_update: 500,
            });
        }

        function setGa4Consent(status: "granted" | "denied") {
            localStorage.setItem("consentGranted", "true");

            gtag("consent", "update", {
                ad_user_data: status,
                ad_personalization: status,
                ad_storage: status,
                analytics_storage: status,
            });
        }

        return {
            provide: {
                setGa4Consent,
                setDefaultGa4Consent,
            },
        };
    },
});
